export default {"src":"/_next/static/media/PlayFilled.f2cdf518.svg","height":33,"width":29,"blurWidth":0,"blurHeight":0};